import React from 'react'
import { Divider, Grid, Skeleton } from '@mui/material'

/**
 * Skeleton Types list loader for add new vehicle.
 * @returns
 */

export const TypeListLoader: React.FC = () => {
  const tableColumns = new Array(7).fill('')
  return (
    <>
      <Skeleton variant='rounded' animation='wave' height={30} width={215} sx={{ mb: 2 }} />
      <Grid container columns={14}>
        {tableColumns.map((_column, index) => {
          return (
            <Grid item xs={2} key={index}>
              <Skeleton variant='text' animation='wave' width={80} height={30} sx={{ mb: 2, ml: index === 0 ? 1 : 'auto', mr: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

/**
 * Skeleton Types select inputs loader for add new vehicle.
 * @returns
 */

export const TypeSelectLoader: React.FC = () => {
  const items = new Array(3).fill('')
  return (
    <Grid container columns={12} spacing={2}>
      {items.map(_item => {
        return (
          <Grid item xs={12}>
            <Skeleton variant='rounded' animation='wave' height={40} />
          </Grid>
        )
      })}
    </Grid>
  )
}
